import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "./UserContext";
import "./css/PaymentFail.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PaymentFail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { cart } = useUser();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");

    if (status === "failure") {
      toast.error("❌ Payment failed. Please try again.");
      window.history.replaceState({}, document.title, "/paymentfail");
    }
  }, [location.search]);

  const handleRetry = () => {
    navigate("/checkout", { state: { cart } });
  };

  return (
    <div className="payment-fail-container">
      <h2>Payment Failed</h2>
      <p>We're sorry, but your payment has failed.</p>
      <button className="retry-button" onClick={handleRetry}>
        Try Again
      </button>
      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
}

export default PaymentFail;
